import { Editor } from 'tinymce';

// Enter is handled here instead of letting TinyMCE/the browser process it: the native
// 'InsertParagraph' command just copies the text of dsv.. probably beacause it cant find a text node to copy.
//So here we just insert BR manually
export function insertParagraphAfterSpan(ed: Editor, span: Node) {
	// for som reason the setContent method does not create an undo point whe called initially
	//so if you load widget, do nothing but press enter and then ctrl+z the whole content will be wiped by UNDO
	ed.undoManager.add();
	ed.undoManager.transact(() => {
		const block = ed.dom.getParent(span, ed.dom.isBlock) ?? ed.getBody();
		const newBlock = ed.dom.create(block.nodeName);

		let node = span.nextSibling;
		while (node) {
			const next = node.nextSibling;
			newBlock.appendChild(node);
			node = next;
		}
		if (!newBlock.hasChildNodes()) {
			newBlock.appendChild(ed.dom.create('br'));
		}

		ed.dom.insertAfter(newBlock, block);
		ed.selection.setCursorLocation(newBlock, 0);
	});
	ed.nodeChanged();
}
